export default {
    'entityName': 'movements',
    upsert: 'full',
    filterStorage: {},
    'pagination': {
      'itemsPerPage': 10,
      'page': 1,
      'sortBy': 'response_date',
      'descending': true
    },
    'fields': [
      {
        value: 'request_date',
        text: 'Date',
        'type': 'date',
        'table': {
          'sortable': true,
          'filter': true
        },
      },
      {
        value: 'protocol_id',
        text: 'Protocol',
        'type': 'autocomplete',
        title: 'protocol.name',
        filter: (_item, search) => ({ 'protocol.name': `%${search}%`}),
        'table': {
          'sortable': true,
          'filter': true
        },
      },
      {
        value: 'type',
        text: 'Type',
        'type': 'list',
        'table': {
          'sortable': true,
          'filter': true
        },
      'list': [
        'REQUEST',
        'TRANSFER',
        'RETURNED',
        'DESTROY',
        'FULLYUSED',
        'UNKNOWN',
        'PATCH'
      ],        
        'validators': [
          'required',
        ]
      },
      {
        "value": "site_id",
        "text": "Site",
        render: ({ site }) => `${site.city} - ${site.code}`,
        "type": "autocomplete",
        filter: (_item, search) => ({ 'name':[
          { 'site.name': `%${search}%`},
          { 'site.city': `%${search}%`},
          { 'site.code': `%${search}%`}
        ]}),
        "table": {
            "sortable": true,
            filter: true
        }
      },
      {
        value: 'drug_id',
        text: 'Drug',
        'type': 'autocomplete',
        title: 'drug.name',
        filter: (_item, search) => ({ 'name':[
          { 'drug.name': `%${search}%`},
        ]}),        
        'table': {
          'sortable': true,
          'filter': true
        },
      },
      {
        value: 'lotto',
        text: 'Batch',
        'type': 'text',
        'table': {
          'sortable': true,
          'filter': true
        },
      }      
    ],
    actions: [{
      value: 'view',
      text: 'View',
      icon: 'mdi-chevron-right',
      disable: item => item.type === 'UNKNOWN'
    }]
  }
  